export default __webpack_public_path__ + "static/media/860d188a28538a7ebf5c8d5d56baefa31581618643319.3c8ff8fd.webp";